module.exports = __webpack_public_path__ + "static/parade-2019-house13-3dc8a9802707ea76b28a1dd950bc00d8.jpg";